export default {
  ensureDataLoaded(context) {
    if (context.state.trendingIndices !== null) return Promise.resolve();

    return context.dispatch('getAllTrendingIndices');
  },
  getAllTrendingIndices(context) {
    // TODO from Nikola: this might need a revisit for more advanced data fetchiing UX.
    if (context.state.trendingIndices === null)
      context.commit('SET_TRENDING_INDICES_LOADING', true);

    return this.dispatch('api/getAllTrendingIndices')
      .then((res) => {
        context.commit('SET_TRENDING_INDICES', res.data);
        // TODO from Nikola: maybe handle the page set outside of the fetch, to more easily support more advanced fetch UX.
        context.commit('SET_TRENDING_INDICES_PAGE', 0);
      })
      .catch((err) => {
        context.commit('SET_TRENDING_INDICES_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_TRENDING_INDICES_LOADING', false);
      });
  },
  showNextPage(context) {
    context.commit('INCREMENT_TRENDING_INDICES_PAGE');
  },
};
